(function () {
  'use strict';

  // =============================================================================
  // プレオープンチケット (2609ssk) — 共有モジュール (window.KBPreopen)
  // =============================================================================
  // 購入制限 (1 枚 = 1 名 / 1 アカウント 2 枚まで / 2 枚目は 1 枚目と同じ枠) は 3 層で守る:
  //   1. 商品ページ   assets/preopen-limit.js      … 数量上限・枠固定・追加ボタン無効化・追加のブロック
  //   2. カート       assets/preopen-cart-guard.js … checkout ボタン無効化 (ページ・ドロワー)
  //   3. API          /api/2609ssk/ticket/status の allowance と over_limit 判定 (最終防衛線。券面は
  //                   over_limit のチケットを描画しない)
  // 1・2 はベストエフォート (サーバー強制ではない)。この 2 スクリプトが共有する定数・文言・
  // allowance キャッシュ・カート集計をここに置く。同じ <script> が 2 回読まれても 1 回だけ初期化する。
  if (window.KBPreopen) return;

  // 1 アカウントあたりの上限枚数。API 側 lib/2609ssk-event.ts の MAX_PERSONS_PER_CUSTOMER と同じ値を保つ。
  // API が応答したときは allowance.max を優先する
  var MAX = 2;
  var SKU_PREFIX = 'PREOPEN-';
  var STATUS_PATH = '/api/2609ssk/ticket/status';
  var TICKET_URL = '/pages/ticket-2609ssk';
  var CHECKOUT_URL = '/checkout';
  var CART_JSON_URL = '/cart.js';
  var CACHE_PREFIX = 'kb_preopen_allow:';
  var CACHE_TTL_MS = 15 * 1000;

  // Horizon のフック (両スクリプトが依存する DOM / イベント)
  var SELECTORS = {
    productForm: 'product-form-component',
    variantPicker: 'variant-picker',
    quantityInput: 'quantity-selector-component input[name="quantity"]',
    addToCartButtons: 'product-form-component button[ref="addToCartButton"], sticky-add-to-cart button[ref="addToCartButton"]',
    checkoutButtons: 'button[name="checkout"], .cart__checkout-button',
    checkoutWrap: '.cart__ctas',
    cartComponents: 'cart-drawer-component, cart-items-component',
    cartDrawer: 'cart-drawer-component',
  };
  var EVENTS = {
    cartUpdate: 'cart:update',                 // cart-items-component / product-form が document までバブル
    variantUpdate: 'variant:update',           // variant-picker が morph 後にセクションへバブル
    quantityUpdate: 'quantity-selector:update',
    dialogClose: 'dialog:close',               // dialog-component (カートドロワー)
  };

  // ---------------------------------------------------------------------------
  // 文言 (ここ以外に持たない)。戻り値は { text, link?, href?, br? }
  // text 内の \n は描画時に改行になる
  // br: true ならリンクの前で改行する / after はリンクの後ろに続く文字列
  // ---------------------------------------------------------------------------
  function m(text, link, href, br, after) {
    return link ? { text: text, link: link, href: href, br: !!br, after: after || '' } : { text: text };
  }
  // 券面ページへの導線。補足がアラート色のときも、この行だけは本文色で出す
  function ticketLink() {
    var msg = m('', '購入済みのチケットはこちら', TICKET_URL);
    msg.plain = true;
    return msg;
  }

  var MESSAGES = {
    // 商品ページ: 追加できない理由 (アラート) / 状態行の補足
    // 購入済みだけで上限 (カートは空)
    limitReachedPurchased: function (max) {
      return [m('購入上限（' + max + '枚）に達しています。'), ticketLink()];
    },
    // 購入済みとカートの合計で上限。チェックアウト案内 + 購入済みへの導線 (2 行)
    limitReachedBoth: function (max) {
      return [
        m('購入上限（' + max + '枚）に達しています。カートの内容をご確認の上、', 'チェックアウト', CHECKOUT_URL, false, 'にお進みください'),
        ticketLink(),
      ];
    },
    limitReachedCart: function (max) { return m('購入上限（' + max + '枚）に達しています。カートの内容をご確認の上、', 'チェックアウト', CHECKOUT_URL, false, 'にお進みください'); },
    overWithPurchasedAndCart: function (purchased, inCart, max) { return m('購入済み' + purchased + '枚とカートの' + inCart + '枚を合わせてお1人様' + max + '枚までです'); },
    overWithCart: function (inCart, max) { return m('カートにすでに' + inCart + '枚あります。お1人様' + max + '枚までです'); },
    overWithPurchased: function (purchased, max) { return m('購入済み' + purchased + '枚と合わせてお1人様' + max + '枚までです'); },
    overMax: function (max) { return m('お1人様' + max + '枚までです'); },
    sameSlotOnly: function (label) { return m('同伴者分は同じ枠（' + label + '）のみ追加できます'); },
    companionHint: function () { return m('同伴者分は同じ枠のみ追加できます'); },
    // 購入済みがあるときは券面への導線も添える
    companionHintWithTicket: function () { return [m('同伴者分は同じ枠のみ追加できます'), ticketLink()]; },
    checking: function () { return m('確認中です。少しお待ちください'); },
    // 商品ページ: 状態行の事実
    factInCart: function (persons, labels) { return persons + '枚カートに追加済み（' + labels + '）'; },
    factPurchased: function (persons, label) { return persons + '枚購入済み（' + label + '）'; },
    // カートガード
    cartOverMax: function (max, persons) { return m('プレオープンチケットはお1人様' + max + '枚までです。カートに' + persons + '枚入っています。枚数を減らしてください。'); },
    cartMixedSlots: function () { return m('同伴者分は1枚目と同じ枠のみご購入いただけます。カート内のチケットの枠が異なります。どちらかを削除してください。'); },
    cartOverAllowance: function (purchased, max, remaining) { return m('購入済み' + purchased + '枚と合わせてお1人様' + max + '枚までです。カートのチケットを' + remaining + '枚に減らしてください。'); },
    cartSlotMismatch: function (label) { return m('同伴者分は同じ枠（' + label + '）のみご購入いただけます。カート内のチケットは別の枠です。'); },
  };

  // ---------------------------------------------------------------------------
  // allowance (sessionStorage 15 秒キャッシュ + 進行中の取得の共有)
  // ---------------------------------------------------------------------------
  var inflight = {};

  function cacheKey(customerId) {
    return CACHE_PREFIX + customerId;
  }

  function getCached(customerId) {
    try {
      var raw = sessionStorage.getItem(cacheKey(customerId));
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || Date.now() - obj.ts > CACHE_TTL_MS) return null;
      return obj.allowance || null;
    } catch (e) {
      return null;
    }
  }

  function setCached(customerId, allowance) {
    try {
      sessionStorage.setItem(cacheKey(customerId), JSON.stringify({ ts: Date.now(), allowance: allowance }));
    } catch (e) { /* noop */ }
  }

  // cart:update / pageshow で呼ぶ。キャッシュと進行中の取得を捨てる
  function clearAllowanceCache() {
    inflight = {};
    try {
      var keys = [];
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        if (k && k.indexOf(CACHE_PREFIX) === 0) keys.push(k);
      }
      for (var j = 0; j < keys.length; j++) sessionStorage.removeItem(keys[j]);
    } catch (e) { /* noop */ }
  }

  function isAllowance(a) {
    return !!a && typeof a.remaining === 'number' && typeof a.max === 'number';
  }

  // { apiBase, customerId, customerHmac, force } → Promise<allowance|null>
  // null = 未ログイン or 取得失敗 (呼び出し側は fail-open で扱う)
  function fetchAllowance(opts) {
    if (!opts || !opts.apiBase || !opts.customerId || !opts.customerHmac) return Promise.resolve(null);
    var cid = String(opts.customerId);
    if (!opts.force) {
      var cached = getCached(cid);
      if (cached) return Promise.resolve(cached);
    }
    if (inflight[cid]) return inflight[cid];
    var p = fetch(opts.apiBase.replace(/\/+$/, '') + STATUS_PATH, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Customer-Id': cid,
        'X-Customer-HMAC': opts.customerHmac,
      },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('status_' + res.status);
        return res.json();
      })
      .then(function (data) {
        var a = data && data.allowance;
        if (!isAllowance(a)) return null;
        setCached(cid, a);
        return a;
      })
      .catch(function (err) {
        console.warn('[preopen] allowance fetch failed:', err && err.message);
        return null;
      })
      .then(function (a) {
        if (inflight[cid] === p) delete inflight[cid];
        return a;
      });
    inflight[cid] = p;
    return p;
  }

  // ---------------------------------------------------------------------------
  // カート
  // ---------------------------------------------------------------------------
  function readCart() {
    return fetch(CART_JSON_URL, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  // cart:update の event.detail.resource がカート JSON なら再取得せずに使う
  // (product-form の追加イベントは resource が {} なので null → 呼び出し側が /cart.js を読む)
  function cartFromEvent(event) {
    var r = event && event.detail && event.detail.resource;
    return r && Array.isArray(r.items) ? r : null;
  }

  // カート JSON → プレオープン明細の集計 { persons, skus, titles }
  //   persons: 枚数 (= 人数)、skus: 枠 (SKU) の一覧、titles: SKU → バリアント名
  function summarizeCart(cart) {
    var persons = 0;
    var skus = [];
    var titles = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var sku = it.sku || '';
      if (sku.indexOf(SKU_PREFIX) !== 0) continue;
      persons += it.quantity || 0;
      if (skus.indexOf(sku) === -1) skus.push(sku);
      titles[sku] = it.variant_title || it.title || sku;
    }
    return { persons: persons, skus: skus, titles: titles };
  }

  function emptyCartSummary() {
    return { persons: 0, skus: [], titles: {} };
  }

  window.KBPreopen = {
    MAX: MAX,
    SKU_PREFIX: SKU_PREFIX,
    STATUS_PATH: STATUS_PATH,
    TICKET_URL: TICKET_URL,
    SELECTORS: SELECTORS,
    EVENTS: EVENTS,
    MESSAGES: MESSAGES,
    fetchAllowance: fetchAllowance,
    clearAllowanceCache: clearAllowanceCache,
    readCart: readCart,
    cartFromEvent: cartFromEvent,
    summarizeCart: summarizeCart,
    emptyCartSummary: emptyCartSummary,
  };
})();
